<template>
  <div class="px-5">
    <v-col cols="12" class="py-0 group-bread-scrumb">
        <router-link :to="{name: 'Product'}">
          Quản lý sản phẩm
        </router-link>
        <span> > </span>
        <router-link v-if="!product.id" :to="{name: 'CreateProduct'}">
          Thêm mới sản phẩm
        </router-link>
        <router-link v-if="product.id" :to="{name: 'UpdateProduct'}">
          Chỉnh sửa sản phẩm
        </router-link>
    </v-col>
    <div class="create-form">
      <validation-observer ref="validator" v-slot="{ handleSubmit }">
        <v-col cols="12">
          <div class="justify-end d-flex">
            <v-btn
              class="btn-save"
              small
              @click.prevent="handleSubmit(saveProduct);validateForm()"
            >
              <span v-if="!product.id">Lưu</span>
              <span v-if="product.id">Cập nhật</span>
            </v-btn>

            <v-btn
              class="btn-cancel mx-0"
              small
              @click="cancel"
            >
              Hủy
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12">
          <div class="group-form">
            <v-row>
              <v-col cols="12" class="py-0 pt-2 px-8">
                <h3>Thông tin cơ bản</h3>
              </v-col>
              <v-col cols="6" class="px-8 py-0 pt-2">
                <p class="text-bold mb-1">Tên sản phẩm*</p>
                <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ required: true}"
                  name="Tên sản phẩm"
                >
                  <v-text-field
                    class="text-field"
                    :error-messages="errors"
                    :clearable="true"
                    placeholder="Vui lòng nhập tên sản phẩm"
                    outlined
                    dense
                    maxLength="100"
                    v-model="product.name"
                  ></v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="6" class="px-8 py-0 pt-2">
                <p class="text-bold mb-1">Mã sản phẩm*</p>
                <v-text-field
                  class="text-field"
                  :clearable="true"
                  placeholder="__"
                  outlined
                  dense
                  readonly
                  v-model="product.code"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="px-8 py-0">
                <p class="text-bold mb-1">Mô tả sản phẩm</p>
                <v-textarea
                  class="text-field"
                  :clearable="true"
                  placeholder="Nhập mô tả sản phẩm"
                  outlined
                  dense
                  maxLength="255"
                  rows="1"
                  auto-grow
                  v-model="product.description"
                ></v-textarea>
              </v-col>
            </v-row>
          </div>
        </v-col>

        <v-col cols="12">
          <div class="group-form">
            <v-row>
              <v-col cols="12 py-0 pt-2 px-8">
                <h3>Phân loại sản phẩm</h3>
              </v-col>
              <v-col cols="4" class="px-8 py-0 pt-2">
                <p class="text-bold mb-1">Danh mục*</p>
                <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ required: true}"
                  name="Danh mục"
                >
                  <v-select
                    class="text-field v-select-custom"
                    :error-messages="errors"
                    :clearable="true"
                    :items="categories"
                    item-value="id"
                    item-text="name"
                    :aLight="'right'"
                    placeholder="Chọn danh mục"
                    attach
                    outlined
                    dense
                    multiple
                    v-model="product.categoryIds"
                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                  ></v-select>
                </validation-provider>
              </v-col>
              <v-col cols="4" class="px-8 py-0 pt-2">
                <p class="text-bold mb-1">Hình thức sản phẩm*</p>
                <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ required: true}"
                  name="Hình thức sản phẩm"
                >
                  <v-select
                    class="text-field"
                    :error-messages="errors"
                    :clearable="true"
                    :items="productTypes"
                    item-value="id"
                    item-text="name"
                    :aLight="'right'"
                    placeholder="Chọn hình thức sản phẩm"
                    attach
                    outlined
                    dense
                    v-model="product.type"
                    :disabled="!!product.id"
                    @change="onChangeProductType"
                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                  ></v-select>
                </validation-provider>
              </v-col>
              <v-col cols="4" class="px-8 py-0 pt-2">
                <p class="text-bold mb-1">Trạng thái*</p>
                <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ required: true}"
                  name="Trạng thái"
                >
                  <v-select
                    class="text-field"
                    :error-messages="errors"
                    :clearable="true"
                    :items="statuses"
                    item-value="id"
                    item-text="name"
                    :aLight="'right'"
                    placeholder="Chọn"
                    attach
                    outlined
                    dense
                    v-model="product.status"
                    @change="onChangeStatus"
                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                  ></v-select>
                </validation-provider>
              </v-col>
              <v-col cols="4" class="px-8 py-0 pt-2">
                <p class="text-bold mb-1">Module care chăm sóc*</p>
                <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ required: true }"
                  name="Module care chăm sóc"
                >
                  <v-select
                    class="text-field"
                    :error-messages="errors"
                    :clearable="true"
                    :items="campaignBu"
                    item-value="code"
                    item-text="name"
                    :aLight="'right'"
                    placeholder="Chọn"
                    attach
                    outlined
                    dense
                    v-model="product.revenueRecognition"
                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                  ></v-select>
                </validation-provider>
              </v-col>
              <v-col cols="4" class="px-8 py-0 pt-2">
                <p class="text-bold mb-1">Nhóm sản phẩm CRM*</p>
                <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ required: true }"
                  name="Nhóm sản phẩm CRM"
                >
                  <v-autocomplete
                    class="text-field"
                    :error-messages="errors"
                    :clearable="true"
                    :items="crmProductGroupCodes"
                    item-value="code"
                    item-text="name"
                    :aLight="'right'"
                    placeholder="Chọn nhóm sản phẩm"
                    attach
                    outlined
                    dense
                    v-model="product.crmProductGroupCode"
                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                  ></v-autocomplete>
                </validation-provider>
              </v-col>
              <v-col cols="4" class="px-8 py-0 pt-2">
                <p class="text-bold mb-1">Trung tâm phụ trách*</p>
                <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ required: true }"
                  name="Trung tâm phụ trách"
                >
                  <v-select
                    class="text-field"
                    :error-messages="errors"
                    :clearable="true"
                    :items="campaignBu"
                    item-value="code"
                    item-text="name"
                    :aLight="'right'"
                    placeholder="Chọn"
                    attach
                    outlined
                    dense
                    v-model="product.responsibleCenterCode"
                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                  ></v-select>
                </validation-provider>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </validation-observer>
        <v-col cols="12">
          <div class="group-form">
            <DuoSkuList
              v-if="product.type === productTypeDuo && productAttributes"
              :productAttributes="productAttributes"
              :skuItems="skuItems"
              :productId="productId"
              :isCreateData="isCreateData"
              :isUpdateDone="isUpdateDone"
              @searchSkuOffline="searchSkuOffline"
              @onUpdateRow="handleUpdateRow"
              @onCreateRow="handleCreateRow"
              @onCreateSKU="handleCreateSKU"
              @onCloneSKU="cloneCreateSKU"
              @onEditRow="handleEditRow"
              />
            <TutorSkuList
              v-if="product.type === productTypeTutor && productAttributes && curriculums.length"
              :productAttributes="productAttributes"
              :skuItems="skuItems"
              :curriculums-obj="curriculumsObj"
              :curriculums="curriculums"
              :productId="productId"
              :isCreateData="isCreateData"
              :isUpdateDone="isUpdateDone"
              @searchSkuOffline="searchSkuOffline"
              @onUpdateRow="handleUpdateRow"
              @onCreateRow="handleCreateRow"
              @onCreateSKU="handleCreateSKU"
              @onCloneSKU="cloneCreateSKU"
              @onEditRow="handleEditRow"
              />
            <ComboSkuList
              v-if="product.type === productTypeCombo && productAttributes"
              :categories="categories" :productAttributes="productAttributes"
              :skuItems="skuItems"
              :productId="productId"
              @searchSkuOffline="searchSkuOffline"
              @reloadSkuList="getListSku"
              />
            <ArtifactSkuList
              v-if="product.type === productTypeArtifact && productAttributes && curriculums.length"
              :productAttributes="productAttributes"
              :skuItems="skuItems"
              :curriculums-obj="curriculumsObj"
              :curriculums="curriculums"
              :productId="productId"
              :isCreateData="isCreateData"
              @searchSkuOffline="searchSkuOffline"
              @onUpdateRow="handleUpdateRow"
              @onCreateRow="handleCreateRow"
              @onCreateSKU="handleCreateSKU"
              @onCloneSKU="cloneCreateSKU"
              @onEditRow="handleEditRow"
              />
          </div>
        </v-col>
    </div>
  </div>
</template>

<script>
import * as moment from 'moment';

import {
  productTypeDuo,
  productTypeTutor,
  productTypeCombo,
  productTypeArtifact,
} from '../../helpers/constants';

import RepositoryFactory from '@/repositories/RepositoryFactory';
const ProductRepository = RepositoryFactory.get('product');
const CampaignRepository = RepositoryFactory.get('campaign');

import DuoSkuList from './components/detail/DuoSkuList.vue';
import TutorSkuList from './components/detail/TutorSkuList.vue';
import ComboSkuList from './components/detail/ComboSkuList.vue';
import ArtifactSkuList from './components/detail/ArtifactSkuList.vue';

import Product from './models/Product';
import SkuDuo from './models/SkuDuo';
import SkuCombo from './models/SkuCombo';
import SkuTutor from "@/pages/product-management/models/SkuTutor";
import {formatDate} from "@/helpers/utils";
import SkuArtifact from './models/SkuArtifact';

export default {
  name: 'detail',
  components: {
    DuoSkuList,
    TutorSkuList,
    ComboSkuList,
    ArtifactSkuList,
  },
  props:{
    // data: {
    //   type: Array,
    //   default: () => [],
    // },
  },
  data() {
    return {
      isCreateData: false,
      tab: 0,
      isShowSku: false,
      productTypes: [],
      product: new Product({}),
      productTypeDuo,
      productTypeTutor,
      productTypeCombo,
      statuses: [],
      skuItems: [],
      productAttributes: null,
      categories: [],
      productId: null,
      curriculumsObj: {},
      curriculums: [],
      allSkus: [],
      campaignBu: [],
      crmProductGroupCodes: [],
      productTypeArtifact,
      isUpdateDone: false,
    };
  },
    computed: {
    },
    async created() {
      await this.getAllSkus();
      this.getListAttributes();
      this.getCurriculumAttributes();
      this.getCategories();
      if (this.$route.params.id) {
          this.getDetail(this.$route.params.id);
          this.productId = parseInt(this.$route.params.id);
      }
      this.getCampaignAttributes();
      this.getCrmProductGroupCodes();
    },
    beforeDestroy() {
    },
  methods: {
    async getCrmProductGroupCodes() {
      const response = await ProductRepository.getCrmProductGroupCodes();
      if (response.success) {
        this.crmProductGroupCodes = response.data;
      }
    },
    compare(a, b) {
      if (b.id > a.id) {
        return 1;
      }
      if (a.id > b.id) {
        return -1;
      }
      return 0;
    },
    async handleCreateRow(item) {
        try {
            const data = {
                "productId": this.productId,
                "productType": this.product.type,
                ...item.data
            }
            delete data.skuItem.code;
            const response = await ProductRepository.createSku(data)
            if (response.success) {
                this.$swal({
                    type: "success",
                    icon: "success",
                    title: "Thêm sku thành công!",
                    toast: true,
                    showConfirmButton: false,
                    timer: 1500,
                });
                this.isCreateData = true
                await this.getListSku()
                setTimeout(() => {
                    this.isCreateData = false
                }, 1000)
            } else {
                this.$swal({
                    type: 'error',
                    title: 'Lỗi !',
                    text: response.errors.message,
                });
            }
        }catch (e) {
            console.log(e)
        }
    },
    handleCreateSKU() {
      let newSku;
      if(this.product.type === this.productTypeDuo) {
          newSku = new SkuDuo({});
      }
      if(this.product.type === this.productTypeTutor) {
          newSku = new SkuTutor({});
      }

      if(this.product.type === this.productTypeArtifact) {
          newSku = new SkuArtifact({});
      }
      this.skuItems.unshift({
          ...newSku,
          isEdit: true
      });
    },
    cloneCreateSKU(item) {
        let newSku;
        if(this.product.type === this.productTypeDuo) {
            newSku = new SkuDuo(item)
        }
        if(this.product.type === this.productTypeTutor) {
            newSku = new SkuTutor(item);
        }

        if(this.product.type === this.productTypeArtifact) {
            newSku = new SkuArtifact(item);
        }
        this.skuItems.unshift({
            ...newSku,
            isEdit: true,
            code: '',
            id: ''
        });
    },
    handleEditRow(item) {
        this.$set(item, 'isEdit', true)
        if(this.product.type === this.productTypeDuo) {
            item.endDate =  item.endDate ? formatDate(item.endDate) : ''
        }
    },
    async handleUpdateRow(contact, item) {
        try {
            const data = {
                "productId": this.productId,
                "productType": this.product.type,
                ...item.data
            };
            const skuCode = item.data.skuItem.code;
            delete item.data.skuItem.code
            const response = await ProductRepository.updateSku(item.skuId, data);
            if (response.success) {
                this.$swal({
                    type: "success",
                    icon: "success",
                    title: "Cập nhật sku thành công!",
                    toast: true,
                    showConfirmButton: false,
                    timer: 1500,
                });
                // await this.getListSku()
                this.$set(contact, 'isEdit', false)
                this.isUpdateDone = true
            } else {
              if (response.errors && response.errors.errors.comboIds) {
                return this.$swal({
                  title: response.errors.message,
                  icon: "error",
                  confirmButtonText: "Xác nhận",
                }).then(async (result) => {
                    if (result.value) {
                      const params = {
                        sku_combo_ids: response.errors.errors.comboIds,
                        sku_code: skuCode,
                      };
                      ProductRepository.exportInvalidCombos(params);
                    } 
                });
              }
              this.$swal({
                type: 'error',
                title: 'Lỗi !',
                text: response.errors.message,
              });
            }
        }catch (e) {
            console.log(e)
        }
    },
    onChangeProductType() {
      this.skuItems = [];
    },
    async getCurriculumAttributes() {
        const res = await ProductRepository.getCurriculumAttributes();
        this.curriculums = res.data;
        res.data.forEach((item) => {
            this.curriculumsObj[item.id] = item;
        })
    },
    async searchSkuOffline(txtSearch) {
    const params = {
        "sku_name": txtSearch
    }
     await this.getListSku(txtSearch ? params : '')
    },
    async getListAttributes() {
      const res = await ProductRepository.getProductAttributes();
      this.productTypes = res.data.productType;
      this.statuses = res.data.productStatus;
      this.productAttributes = res.data;
    },
    async getCategories() {
      const res = await ProductRepository.getCategories();
      res.data.forEach((item) => {
        if (item.rootParentId === item.id) {
          this.categories.push({
            header: item.name,
          });
        }
        this.categories.push({
          id: item.id,
          name: `${item.fullLevelName.join(' > ')}`,
        });
      })
    },
    async getDetail(id) {
      const res = await ProductRepository.getDetail(id);
      const categoryIds = res.data.categories.map((item) => item.id);
      res.data.categoryIds = categoryIds
      this.product = new Product(res.data)
      this.getListSku()
    },
    compareByVal(a, b) {
      return a - b;
    },
    async getListSku(search= {}) {
      this.skuItems = [];
      const params = {
        product_id: this.product.id,
        product_type: this.product.type,
        ...search
      };
      const res = await ProductRepository.advanceSearchForCombo(params);
      // product Duo
      if (this.product.type === this.productTypeDuo){
        res.data.forEach((item) => {
          this.$set(item, 'isEdit', false)
          item.originalName = item.name
          item.originalCardDisplayName = item.cardDisplayName
          item.originalOrgPrice = item.orgPrice
          item.originalSubjectId = item.subjectId
          item.gradeIds.sort(this.compareByVal)
          item.originalGradeIds = item.gradeIds
          item.originalDurationType = item.durationType
          item.originalStatus = item.status
          item.originalEndDate = item.endDate
          item.originalDuration = item.duration
          item.originalTransactionStatus = item.transactionStatus
          const sku = new SkuDuo(item);
          this.skuItems.push(item);
        });
      }
      if (this.product.type === this.productTypeTutor){
          res.data.forEach((item) => {
          this.$set(item, 'isEdit', false)
          item.originalName = item.name
          item.originalCardDisplayName = item.cardDisplayName
          item.originalOrgPrice = item.orgPrice
          item.originalSubjectId = item.subjectId
          item.originalCurriculumId = item.curriculumId
          item.originalLevel = item.level
          item.originalClassTypeId = item.classTypeId
          item.originalTeacherTypeId = item.teacherTypeId
          item.originalNumOfLesson = item.numOfLesson
          item.originalStatus = item.status
          item.originalTransactionStatus = item.transactionStatus
          const sku = new SkuTutor(item);
          this.skuItems.push(item);
          });
      }

      // product Combo
      if (this.product.type === this.productTypeCombo) {
        const skuItems = [];
        res.data.forEach((item) => {
          item.skuDuos.forEach((itemD) => {
            itemD.itemType = 'duo';
            itemD.itemId = itemD.id;
            itemD.itemQuantity = itemD.comboDetail ? itemD.comboDetail.itemQuantity : 1;
            itemD.codeSelect = itemD.code;
            itemD.sumPrice = itemD.itemQuantity * itemD.orgPrice;
            itemD.skuSearchList = this.allSkus;
          });
          item.skuTutors.forEach((itemD) => {
            itemD.itemType = 'tutor';
            itemD.itemId = itemD.id;
            itemD.itemQuantity = itemD.comboDetail ? itemD.comboDetail.itemQuantity : 1;
            itemD.codeSelect = itemD.code;
            itemD.sumPrice = itemD.itemQuantity * itemD.orgPrice;
            itemD.skuSearchList = this.allSkus;
          });
          const comboItems = item.skuDuos.concat(item.skuTutors);
          comboItems.forEach((itemCI) => {
            itemCI.tempItem = itemCI;
          });
          item.comboItems = comboItems;
          item.originalStatus = item.status;
          const sku = new SkuCombo(item);
          skuItems.push(sku);
        });

        // Sort SKU
        const skuActive = [];
        const skuInActive = [];
        skuItems.forEach((item) => {
          if (item.status === 'active') {
            skuActive.push(item);
          }
          if (item.status === 'inactive') {
            skuInActive.push(item);
          }
        })
        skuActive.sort(this.compare);
        skuInActive.sort(this.compare);
        this.skuItems = skuActive.concat(skuInActive);
      }

      if (this.product.type === this.productTypeArtifact){
          res.data.forEach((item) => {
          this.$set(item, 'isEdit', false)
          item.originalName = item.name
          item.originalOrgPrice = item.orgPrice
          item.originalStatus = item.status
          item.originalTransactionStatus = item.transactionStatus
          item.unitType = item.unitType
          const sku = new SkuArtifact(item);
          this.skuItems.push(item);
          });
      }
    },
    cancel() {
      this.$swal
        .fire({
          title: "Bạn muốn đóng form? Tất cả thông tin sẽ bị mất!",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Hủy",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Đồng ý",
        })
        .then( async (result) => {
          if (result?.value) {
            this.$router.push('/products');
          }
        });
    },
    validateForm() {
      if (!this.skuItems.length) {
        this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: 'Sản phẩm phải có tối thiểu 1 SKU',
        });
      }
    },
    hasNullOrEmptyField(obj) {
        const keyOptions = ['id', 'code', 'level'];
        delete obj.id
        delete obj.code
        if(this.product.type === this.productTypeDuo) {
            if(obj.durationType === 'month') {
                delete obj.endDate
            }else {
                delete obj.duration
            }
        }

      for (const key in obj) {
              if ((obj[key] === null || obj[key] === '') && !keyOptions.includes(key)) {
                  return true;
          }
      }
      return false;
    },
    async saveProduct() {
        if (!this.skuItems.length) {
            return;
        }
        let skuList = _.cloneDeep(this.skuItems);
        if (this.product.type === this.productTypeCombo) {
            skuList = this.skuItems.map((itemSku) => {
                const comboItems = itemSku.comboItems.map((cbi) => {
                    return {
                    itemType: cbi.itemType,
                    itemId: cbi.itemId,
                    itemQuantity: cbi.itemQuantity,
                    };
                });

                return {
                    name: itemSku.name,
                    description: itemSku.description,
                    orgPrice: itemSku.orgPrice,
                    comboPrice: itemSku.comboPrice,
                    status: itemSku.status,
                    transactionStatus: itemSku.transactionStatus,
                    cardDisplayName: itemSku.cardDisplayName,
                    comboItems,
                };
            });
        }

        if (this.product.type === this.productTypeTutor || this.product.type === this.productTypeDuo ) {
            let isValidateEdit = false
            isValidateEdit = this.skuItems.some(item => item.isEdit)
            if (isValidateEdit) {
                this.$swal({
                    type: 'error',
                    title: 'Lỗi !',
                    text: 'Vui lòng nhập đủ thông tin SKU',
                });
                return
            }
            skuList = skuList.map((itemSku) => {
                delete itemSku.id
                delete itemSku.code
                delete itemSku.isEdit
                return itemSku
            });
        }

        if (this.product.type === this.productTypeArtifact) {
            let isValidateEdit = false
            isValidateEdit = this.skuItems.some(item => item.isEdit)
            if (isValidateEdit) {
                this.$swal({
                    type: 'error',
                    title: 'Lỗi !',
                    text: 'Vui lòng nhập đủ thông tin SKU',
                });
                return
            }
            skuList = skuList.map((itemSku) => {
                delete itemSku.id
                delete itemSku.code
                delete itemSku.isEdit
                return itemSku
            });
        }

        if (!this.product.id) {
            const isExistSkuActive = this.skuItems.find(item => item.status === 'active');
            if (this.product.status === 'inactive' && isExistSkuActive) {
                return this.$swal({
                    type: 'error',
                    title: 'Lỗi !',
                    text: 'Vẫn còn SKU đang hoạt động. Đề nghị kiểm tra lại.',
                });
            }
            if (this.product.type === this.productTypeTutor || this.product.type === this.productTypeDuo ) {
                let isValidateCreate = false
                this.skuItems.forEach(item => {
                    if (this.hasNullOrEmptyField(item)) {
                        isValidateCreate = true;
                    }
                })
                if(isValidateCreate) {
                    this.$swal({
                        type: 'error',
                        title: 'Lỗi !',
                        text: 'Vui lòng nhập đủ thông tin SKU',
                    });
                    return
                }
            }

            const params = {
              name: this.product.name.trim(),
              description: this.product.description ? this.product.description.trim() : null,
              type: this.product.type,
              status: this.product.status,
              revenueRecognition: this.product.revenueRecognition,
              crmProductGroupCode: this.product.crmProductGroupCode,
              categoryIds: this.product.categoryIds,
              skuItems: skuList,
              responsibleCenterCode: this.product.responsibleCenterCode,
            };

            const res = await ProductRepository.create(params);
            if (res.data && res.data.id) {
                this.$swal({
                    type: "success",
                    icon: "success",
                    title: "Tạo thành công !",
                    toast: true,
                    showConfirmButton: false,
                    timer: 1500,
                });
                return this.$router.push('/products');
            } else {
                this.$swal({
                    type: 'error',
                    title: 'Lỗi !',
                    text: res.message,
                });
            }
        }

        if (this.product.id) {
                const params = {
                    name: this.product.name.trim(),
                    description: this.product.description ? this.product.description.trim() : null,
                    status: this.product.status,
                    revenueRecognition: this.product.revenueRecognition,
                    crmProductGroupCode: this.product.crmProductGroupCode,
                    type: this.product.type,
                    categoryIds: this.product.categoryIds,
                    responsibleCenterCode: this.product.responsibleCenterCode,
                };

            const res = await ProductRepository.update(this.product.id, params);
            if (res.data && res.data[0] == 1) {
                this.$swal({
                    type: "success",
                    icon: "success",
                    title: "Cập nhật thành công !",
                    toast: true,
                    showConfirmButton: false,
                    timer: 1500,
                });

                // return this.$router.push('/products');
                return;
            } else {
                this.$swal({
                    type: 'error',
                    title: 'Lỗi !',
                    text: res.message,
                });
            }
        }
    },
    async getAllSkus() {
      const params = {
        sku_name: '',
      }
      const res = await ProductRepository.basicSearchForCombo(params);
      this.allSkus = res.data;
    },
    onChangeStatus() {
        const isExistSkuActive = this.skuItems.find((item) => item.originalStatus === 'active');
        if (this.product.id && isExistSkuActive && this.product.status === 'inactive') {
            this.$swal({
                type: 'error',
                title: 'Lỗi !',
                text: 'Vẫn còn SKU đang hoạt động. Đề nghị kiểm tra lại.',
            });
            setTimeout(() => {
                this.product.status = 'active';
            }, 0)
        }
    },
    async getCampaignAttributes() {
      const res = await CampaignRepository.getOptions();
      this.campaignBu = res.data.campaignBu;
    },
  }
};
</script>
<style scoped lang="scss">
  .btn-save {
    background: #8465FF !important;
    color: #fff;
  }
  .btn-cancel  {
    background: #787878 !important;
    color: #fff;
  }
  .create-form {
    background: #fff;
  }
  .group-form {
    background: #FAFBFF;
    border-radius: 10px;
    box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
  }
  .text-bold {
    font-weight: bold;
  }

  .btn-info {
    background: #6587FF !important;
    color: #fff;
  }

  .icon-search {
    left: 40px;
    position: relative;
  }
  .table-custom {
    th {
      background: #E7E8FF;
      border-left: 1px solid #fff;
    }
  }
</style>

<style lang="scss">
  .text-field fieldset {
    background: #fff !important;
  }
  .text-search {
    .v-input__slot {
      min-height: 20px !important;
      padding-left: 35px !important;
    }
  }

  .v-select-custom {
    .v-subheader {
      font-weight: bold;
      background: #ECECEC;
      color: #000;
    }
  }

  .group-bread-scrumb {
    position: relative;
    top: -30px;
    z-index: 99;
    height: 0;
    font-weight: bold;
    font-size: 17px;
    a {
      text-decoration: none !important;
      color: #000;
    }
  }
</style>
